import { __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import { Wix } from '@wix/js-sdk-provider';
import ReactResizeDetector from 'react-resize-detector';
import { ArrowIcon } from './ArrowIcon';
import { Badge } from '../Badge';
import './badge-list.scss';
import { getTranslationFunction } from '../../services/i18n';
var marginBottom = 4;
var PRIMARY_COLOR = 'color-5';
var BadgeList = /** @class */ (function (_super) {
    __extends(BadgeList, _super);
    function BadgeList(props) {
        var _this = _super.call(this, props) || this;
        _this.siteColors = _this.props.siteColors;
        _this.setWrapperRef = function (element) {
            _this.wrapperRef = element;
        };
        _this.setRemainderRef = function (element) {
            _this.remainderRef = element;
        };
        _this.getBadgeHeight = function () {
            var ref = _this.wrapperRef;
            if (ref) {
                var firstChild = ref.childNodes[0];
                if (!firstChild) {
                    return 0;
                }
                var badgeHeight = firstChild.scrollHeight;
                var margin = parseInt(window.getComputedStyle(firstChild).getPropertyValue('margin-bottom'), 10);
                return badgeHeight + margin;
            }
            return 0;
        };
        _this.getColor = function (colorName) {
            var _a;
            return _this.siteColors &&
                _this.siteColors.find(function (color) { return color.reference === colorName; })
                ? (_a = _this.siteColors.find(function (color) { return color.reference === colorName; })) === null || _a === void 0 ? void 0 : _a.value : 'black';
        };
        _this.getRemainderColor = function () {
            return _this.props.remainderColor || _this.getColor(PRIMARY_COLOR);
        };
        _this.filterBadges = function () {
            var filteredBadges = _this.state.filteredBadges;
            var _a = _this.props, badges = _a.badges, maxRows = _a.maxRows, maxBadges = _a.maxBadges;
            if (maxBadges && maxBadges > 0) {
                _this.setState({
                    wrapperHeight: undefined,
                    remainder: badges.length - maxBadges,
                    filteredBadges: filteredBadges.length !== maxBadges
                        ? badges.slice(0, maxBadges)
                        : filteredBadges,
                });
                return;
            }
            var ref = _this.wrapperRef;
            if (ref) {
                if (_this.remainderRef) {
                    ref.removeChild(_this.remainderRef);
                }
                var tops_1 = [];
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (var i = 0; i < ref.childNodes.length; i++) {
                    var child = ref.childNodes[i];
                    tops_1.push(child.offsetTop);
                }
                var uniqueTops = Array.from(new Set(tops_1));
                var maxRowsReached = uniqueTops[maxRows - 1] === undefined;
                var finalTop_1 = maxRowsReached
                    ? uniqueTops[uniqueTops.length - 1]
                    : uniqueTops[maxRows - 1];
                var wrapperHeight_1 = finalTop_1 + _this.getBadgeHeight() - marginBottom;
                var remainder_1 = tops_1.filter(function (top) { return top > finalTop_1; }).length;
                var lastChild = ref.childNodes[tops_1.length - remainder_1];
                ref.insertBefore(_this.remainderRef, lastChild);
                var checkRemainder_1 = function (i) {
                    var _a;
                    if (((_a = _this.remainderRef) === null || _a === void 0 ? void 0 : _a.offsetTop) >= wrapperHeight_1 &&
                        i < tops_1.length) {
                        ref.removeChild(_this.remainderRef);
                        var prevChild_1 = ref.childNodes[tops_1.length - remainder_1 - i];
                        remainder_1++;
                        _this.setState({ remainder: remainder_1 }, function () {
                            ref.insertBefore(_this.remainderRef, prevChild_1);
                            checkRemainder_1(i + 1);
                        });
                    }
                };
                _this.setState({ wrapperHeight: wrapperHeight_1, remainder: remainder_1, filteredBadges: badges }, function () {
                    return checkRemainder_1(1);
                });
            }
        };
        _this.renderRemainder = function () {
            var _a = _this.props, borderRadius = _a.borderRadius, layout = _a.layout, size = _a.size, font = _a.font, useTextRemainder = _a.useTextRemainder, onClickMore = _a.onClickMore, background = _a.background;
            var cursorClass = onClickMore ? 'pointer' : '';
            var borderClass = background ? '' : 'no-border';
            var backgroundClass = background ? '' : 'no-background';
            var remainderClass = classNames('remainder', layout, size, backgroundClass, cursorClass, borderClass);
            var color = _this.getRemainderColor();
            if (_this.state.remainder > 0 && !useTextRemainder) {
                return (React.createElement("div", { onClick: onClickMore, className: remainderClass, style: { borderRadius: borderRadius, color: color, borderColor: color, fontFamily: font } },
                    "+",
                    _this.state.remainder));
            }
            return React.createElement("div", null);
        };
        var maxBadges = props.maxBadges, badges = props.badges;
        _this.state = {
            wrapperHeight: 0,
            remainder: 4,
            filteredBadges: maxBadges && maxBadges > 0 ? badges.slice(0, maxBadges) : props.badges,
        };
        return _this;
    }
    BadgeList.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.filterBadges();
                        if (!this.props.siteColors) {
                            this.siteColors = Wix.Styles.getSiteColors();
                            Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, function () {
                                _this.siteColors = Wix.Styles.getSiteColors();
                                _this.filterBadges();
                            });
                        }
                        if (!!this.t) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, getTranslationFunction(this.props.i18n, this.props.language)];
                    case 1:
                        _a.t = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BadgeList.prototype.componentDidUpdate = function (prev) {
        if (isEqual(this.props, prev)) {
            return;
        }
        this.filterBadges();
    };
    BadgeList.prototype.render = function () {
        var _this = this;
        var filteredBadges = this.state.filteredBadges;
        var _a = this.props, layout = _a.layout, size = _a.size, borderRadius = _a.borderRadius, font = _a.font, background = _a.background, align = _a.align, useTextRemainder = _a.useTextRemainder, onClickMore = _a.onClickMore, hideDefaultIcon = _a.hideDefaultIcon;
        var backgroundClass = background ? '' : 'no-background';
        var wrapperClass = classNames('badge-list-wrapper', layout, size, align, backgroundClass);
        var color = this.getRemainderColor();
        return (React.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: true, onResize: this.filterBadges }, function () {
            var _a;
            return (React.createElement("div", { className: "members-badge-list-lib-style-wrapper" },
                React.createElement("div", { className: wrapperClass, ref: _this.setWrapperRef, style: { height: _this.state.wrapperHeight } },
                    filteredBadges.map(function (badge) { return (React.createElement(Badge, { key: badge.id, badge: badge, layout: layout, size: size, borderRadius: borderRadius, font: font, background: background, onLoadIcon: _this.filterBadges, onClick: _this.props.onBadgeClick, hideDefaultIcon: hideDefaultIcon, httpClient: _this.props.httpClient })); }),
                    React.createElement("span", { ref: _this.setRemainderRef }, _this.renderRemainder())),
                useTextRemainder && _this.state.remainder > 0 && !!onClickMore && (React.createElement("div", { className: "textRemainderWrapper" },
                    React.createElement("span", { onClick: onClickMore, style: { fontFamily: font, color: color } },
                        React.createElement("span", null, (_a = _this.t) === null || _a === void 0 ? void 0 : _a.call(_this, 'view_all_badges')),
                        React.createElement(ArrowIcon, null))))));
        }));
    };
    return BadgeList;
}(React.Component));
export { BadgeList };
//# sourceMappingURL=BadgeList.js.map